import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import ContactPage from "./pages/ContactPage";
import HowItWorks from "./components/howItWorks";
import Blog from "./components/blog";
import Footer from "./components/footer";
import RegistrationPage from "./pages/RegistrationPage";
import ScrollToTopButton from "./components/ScrollToTopButton";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import DemoPage from "./pages/DemoPage";
import RegistrationSuccess from "./components/RegistrationSuccess";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Routes>
        <Route
          path="/"
          element={
            <div className="main-content">
              <Header data={landingPageData.Header} />
              <About data={landingPageData.About} />
              <Services data={landingPageData.Services} />
              <Features data={landingPageData.Features} />
              <HowItWorks data={landingPageData.HowItWorks} />

              <Testimonials data={landingPageData.Testimonials} />
              <Team data={landingPageData.Team} />
              <Footer data={landingPageData.footer} />
            </div>
          }
        />
        <Route path="/contact/*" element={<div className="main-content"><ContactPage /></div>} />
        <Route path="/register" element={<div className="main-content"><RegistrationPage /></div>} />
        <Route path="/blogs" element={<div className="main-content"><Blog data={landingPageData.blogs} showMainHeading={true} /><Footer data={landingPageData.footer} /></div>} />
        <Route path="/privacy-policy" element={<div className="main-content"><PrivacyPolicy /></div>} />
        <Route path="/terms-and-conditions" element={<div className="main-content"><TermsAndConditions /></div>} />
        <Route path="/demo/:productId" element={<div className="main-content"><DemoPage /></div>} />
        <Route path="/registration-success" element={<div className="main-content"><RegistrationSuccess /></div>} />
      </Routes>
      <ScrollToTopButton />
    </div>
  );
};

export default App;
